import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomSpinner = createSvgIcon(
  <path d="M13.875 3.875a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m0 16.25a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m-10-6.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75M22 12a1.875 1.875 0 1 0-3.75 0A1.875 1.875 0 0 0 22 12M7.582 19.07a1.875 1.875 0 1 0-2.652-2.652 1.875 1.875 0 0 0 2.652 2.652m0-11.492A1.875 1.875 0 1 0 4.93 4.93a1.875 1.875 0 1 0 2.652 2.652zm8.836 11.492a1.875 1.875 0 1 0 2.652-2.652 1.875 1.875 0 0 0-2.652 2.652" />,
  'CustomSpinner',
);

export default CustomSpinner;
